import type { OptionPreview } from '@/types/collection';

/**
 * Строка сводки: параметр, его текущее значение и переход в шторку.
 *
 * Весь выбор виден одним списком, поэтому поменять одну локацию — два
 * нажатия, а не проход по всем шагам заново.
 */
interface SummaryRowProps {
  label: string;
  /** Текущее значение или null, если ещё не выбрано. */
  value: string | null;
  preview?: OptionPreview | undefined;
  required: boolean;
  onOpen: () => void;
}

export function SummaryRow({ label, value, preview, required, onOpen }: SummaryRowProps) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex w-full items-center gap-3 border-b border-border bg-surface px-3.5 py-3 text-left last:border-b-0 hover:bg-surface-2"
    >
      <span className="w-32 shrink-0 text-sm text-text-2">{label}</span>

      <span className="flex min-w-0 flex-1 items-center gap-2">
        {preview?.kind === 'colors' && (
          <span className="flex shrink-0 overflow-hidden rounded-sm border border-border">
            {preview.colors.map((color) => (
              <i key={color} className="block h-3 w-3" style={{ backgroundColor: color }} />
            ))}
          </span>
        )}
        <span className={`truncate text-sm ${value ? 'text-text' : 'text-text-3'}`}>
          {value ?? (required ? 'Не выбрано' : 'Можно пропустить')}
        </span>
      </span>

      {required && !value && <span className="shrink-0 text-xs text-danger">выбрать</span>}
      {value && <span className="shrink-0 text-xs text-text-3">изменить</span>}
      <span aria-hidden className="shrink-0 text-text-3">
        ›
      </span>
    </button>
  );
}
